import React, { useMemo } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function ProtectedRoute({ children, role }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  const navState = useMemo(() => ({ from: loc.pathname }), [loc.pathname]);
  if (loading) return <div className="py-24 text-center">Loading...</div>;
  if (!user) return <Navigate to="/login" state={navState} replace />;
  if (role && user.role !== role) return <Navigate to="/" replace />;
  return children;
}
